import React from "react";
import type { SendingDomainResponse } from "@common/schemas/sending-domain.schema";
import { PlainModal, StandardModalHeader } from "@design-system/Modal/Modal";
import { DnsRecordsPanel } from "./DnsRecordsPanel";

interface DnsRecordsModalProps {
    domain: SendingDomainResponse | null;
    onClose: () => void;
}

export const DnsRecordsModal: React.FC<DnsRecordsModalProps> = ({
    domain,
    onClose,
}) => (
    <PlainModal show={domain !== null} onHide={onClose} size="lg">
        <StandardModalHeader>DNS records</StandardModalHeader>
        {domain !== null && (
            <DnsRecordsPanel
                domain={domain}
                onVerified={onClose}
                onDismiss={onClose}
            />
        )}
    </PlainModal>
);
